import { tv } from "@fanka/tailwind-variants";

export const WEEK_LABELS = ["日", "月", "火", "水", "木", "金", "土"] as const;

export const DATE_CELL_CLASS_NAME = tv({
  base: "flex h-[40px] flex-col min-w-[45px] max-w-[68px] w-full justify-center items-center px-2 py-1 border-l border-grayScale-200",
  variants: {
    dayType: {
      DEFAULT: "bg-grayScale-0",
      TODAY: "text-ui-0 bg-brand-black border-brand-black",
      SUNDAY: "bg-functional-danger-light",
      SATURDAY: " bg-functional-success-light",
    },
  },
  defaultVariants: {
    dayType: "DEFAULT",
  },
});
